module.exports = __webpack_public_path__ + "5e6f06c28c8f6f9d1dae87fbce3af7fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/4.jpg
// module id = 435
// module chunks = 0 2